import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const setPasswordExpiryPeriod = (tenantName, passwordExpirationPeriod) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.ORGANIZATION_SETTINGS.SET_PASSWORD_EXPIRY_PERIOD(
      tenantName,
      passwordExpirationPeriod
    )
  );
};

export default setPasswordExpiryPeriod;
